.page {
  /* A tab body inside PlatformsLayout → gutter + background come from Layout's
     .main. */
  width: 100%;
  overflow-x: clip;
  /* Same bar height as Titles > Leaderboard. */
  --metric-bar-height: 6px;
}

/* ── Header ──────────────────────────────────────────────── */

.header {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  margin-bottom: var(--space-5);
}

/* Row 1 — Define the universe: Platform / Region / Quarter, one left-aligned
   row. Mirrors Titles > Leaderboard's .defineRow. */
.defineRow {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  flex-wrap: wrap;
}

/* Grow to fit "Platform: Netflix" once set; 180px floor keeps the row even. */
.defineSelect {
  width: auto;
  min-width: 180px;
  max-width: 280px;
}

/* Scope sentence on the left, sort + column picker pushed to the right */
.metaRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-4);
  flex-wrap: wrap;
}

.metaControls {
  display: flex;
  align-items: center;
  gap: var(--space-2);
}

.sortSelect {
  width: 170px;
}

.subtitle {
  margin: 0;
  font-size: var(--text-base);
  color: var(--text-muted);
}

.subtitle strong {
  color: var(--text-secondary);
  font-weight: var(--weight-semi);
}

/* A value the user chose — gold, as on Titles > Leaderboard */
.scopeValue {
  color: var(--accent-secondary-text);
  font-weight: var(--weight-semi);
}

/* ── Table ───────────────────────────────────────────────── */

.tableWrapper {
  width: 100%;
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-lg);
  background: var(--bg-card);
  overflow: hidden;
}

/* ── Platform cell ───────────────────────────────────────── */

.platformLink {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  text-decoration: none;
  min-width: 0;
}

.platformName {
  font-size: var(--text-base);
  font-weight: var(--weight-semi);
  color: var(--text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.platformLink:hover .platformName {
  /* Match the Titles leaderboard's title hover (gold), not accent-primary —
     both leaderboards share the table, so the link hover must read the same. */
  color: var(--accent-secondary-text);
}

/* ── Utilities ───────────────────────────────────────────── */

.noValue {
  color: var(--text-disabled);
}

.notice {
  padding: var(--space-4);
  background: var(--color-danger-muted);
  border: 1px solid var(--color-danger);
  border-radius: var(--radius-lg);
  font-size: var(--text-base);
  color: var(--text-primary);
}

.empty {
  padding: var(--space-12) var(--space-6);
  text-align: center;
  background: var(--bg-card);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-lg);
}

.emptyTitle {
  margin: 0 0 var(--space-2) 0;
  font-size: var(--text-lg);
  font-weight: var(--weight-semi);
  color: var(--text-primary);
}

.emptyBody {
  margin: 0;
  font-size: var(--text-base);
  color: var(--text-muted);
}

@media (max-width: 640px) {
  .page {
    padding: var(--space-4) 0;
  }
}

